export default __webpack_public_path__ + "static/media/Community.2da8f4bb.png";